import Form from 'app/components/Form';

import {
  getAccounts
} from 'app/services/accounts';

import {
  backgroundGravityOptions,
  formatOptions,
  pageModeOptions
} from 'app/utils/options';

import {
  AND_OPERATOR,
} from 'app/hooks/useFilter';

const AccessCodePageForm = props => {
  const {
    accessCodePage,
    onClose,
    onSubmit,
    action
  } = props;

  const getAccountOptions = async (page = 1, perPage = 100, filter = null, id = null) => {
    let params = {
      page,
      per_page: perPage,
      filter_model: {
        name: [{
          filterClass: 'text',
          filterType: 'contains',
          value: filter,
          operator: AND_OPERATOR
        }]
      },
      sort_model: [],
      record_id: id,
    }

    let resp = await getAccounts(params);
    return formatOptions(resp.records);
  }

  let header = null;
  if (action === 'update') {
    header = 'Edit Fields';
  }

  let fields = [
    { name: 'account_id', label: 'Account', type: 'autocomplete', value: accessCodePage?.account_id, valueType: 'integer', getOptions: getAccountOptions, required: true, helperText: 'Account that the page belongs to' },
    { name: 'account_name', label: 'Account Name', type: 'text', value: accessCodePage?.account_name, required: true, helperText: 'The account\'s name as displayed on the page' },
    { name: 'subdomain', label: 'Subdomain', type: 'text', value: accessCodePage?.subdomain, required: true, helperText: 'The subdomain that will host the page' },
    { name: 'header', label: 'Header', type: 'text', value: accessCodePage?.header, required: true, helperText: 'The header displayed on the page' },
    { name: 'head_title', label: 'Head Title', type: 'text', value: accessCodePage?.head_title, required: true, helperText: 'The title tag in the HTML <head> section' },
    { name: 'head_description', label: 'Head Description', type: 'text', value: accessCodePage?.head_description, required: true, helperText: 'The description tag in the HTML <head> section' },
    { name: 'contact_email', label: 'Contact Email', type: 'text', value: accessCodePage?.contact_email, required: true, helperText: 'The contact email address displayed on the page' },
    { name: 'logo_height', label: 'Logo Height', type: 'text', value: accessCodePage?.logo_height, required: true, helperText: 'The height to display the logo in CSS units' },
    { name: 'button_color', label: 'Button Color', type: 'text', value: accessCodePage?.button_color, required: true, helperText: 'The button color in HEX (without the #, will implement color picker)' },
    { name: 'background_color', label: 'Background Color', type: 'text', value: accessCodePage?.background_color, required: false, helperText: 'The background color in HEX (without the #, will implement color picker). Used when a background image is not provided' },
    { name: 'background_gravity', label: 'Background Gravity', type: 'select', value: accessCodePage?.background_gravity, valueType: 'integer', options: backgroundGravityOptions, hideNoneOption: true, helperText: 'The position of the background image' },
    { name: 'page_mode', label: 'Page Mode', type: 'select', value: accessCodePage?.page_mode, valueType: 'integer', options: pageModeOptions, hideNoneOption: true, helperText: 'The page mode of the access code page' },
    { name: 'allow_name', label: 'Allow Name', type: 'checkbox', value: accessCodePage?.allow_name, valueType: 'boolean', helperText: 'Display a name input' },
    { name: 'require_name', label: 'Require Name', type: 'checkbox', value: accessCodePage?.require_name, valueType: 'boolean', helperText: 'Require the name input' },
    { name: 'allow_email', label: 'Allow Email', type: 'checkbox', value: accessCodePage?.allow_email, valueType: 'boolean', helperText: 'Display an email input' },
    { name: 'require_email', label: 'Require Email', type: 'checkbox', value: accessCodePage?.require_email, valueType: 'boolean', helperText: 'Require the email input' },
    { name: 'allow_phone', label: 'Allow Phone', type: 'checkbox', value: accessCodePage?.allow_phone, valueType: 'boolean', helperText: 'Display a phone number input' },
    { name: 'require_phone', label: 'Require Phone', type: 'checkbox', value: accessCodePage?.require_phone, valueType: 'boolean', helperText: 'Require the phone number input' },
    { name: 'allow_zip', label: 'Allow Zip Code', type: 'checkbox', value: accessCodePage?.allow_zip, valueType: 'boolean', helperText: 'Display a zip code input' },
    { name: 'require_zip', label: 'Require Zip Code', type: 'checkbox', value: accessCodePage?.require_zip, valueType: 'boolean', helperText: 'Require the zip code input' },
    { name: 'opt_in_checked', label: 'Opt In Checked', type: 'checkbox', value: accessCodePage?.opt_in_checked, valueType: 'boolean', helperText: 'Default opt in checkbox to checked' }, // Note: default opt-in isn't considered valid for GDPR, the EU's ePrivacy cookie law or California's CCPA
    { name: 'opt_in_message', label: 'Opt In Message', type: 'text', value: accessCodePage?.opt_in_message, helperText: 'Message for opt-in checkbox' },
    { name: 'delay_access', label: 'Delay Access', type: 'checkbox', value: accessCodePage?.delay_access, helperText: 'Prevent access to the consumer app until the notification delay of the job as elapsed' },
    { name: 'registration_message', label: 'Registration Message', type: 'text', value: accessCodePage?.registration_message, helperText: 'Message that\'s displayed when consumer app access has been delayed confirming a customer\'s registration' },
    { name: 'metadata', label: 'Meta Data', type: 'hidden', value: accessCodePage?.metadata, multiple: true },
    { name: 'allow_metadata', label: 'Allow Meta Data', type: 'hidden', value: accessCodePage?.allow_metadata },
  ]

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      onSubmit
    }} />
  );
}

export default AccessCodePageForm;
